export enum PreventiveDentalTreatmentChartFields {
  Treatment1Plan = 'treatment1Plan',
  Treatment1PlanDetail = 'treatment1PlanDetail',
  Treatment1Action = 'treatment1Action',
  Treatment1ActionDetail = 'treatment1ActionDetail',
  Treatment2Plan = 'treatment2Plan',
  Treatment2PlanDetail = 'treatment2PlanDetail',
  Treatment2Action = 'treatment2Action',
  Treatment2ActionDetail = 'treatment2ActionDetail',
}

export enum TreatmentType {
  일차_계획_불소도포 = '일차_계획_불소도포',
  일차_수행_불소도포 = '일차_수행_불소도포',
  이차_계획_불소도포 = '이차_계획_불소도포',
  이차_수행_불소도포 = '이차_수행_불소도포',
  일차_계획_구취측정 = '일차_계획_구취측정',
  일차_수행_구취측정 = '일차_수행_구취측정',
  이차_계획_구취측정 = '이차_계획_구취측정',
  이차_수행_구취측정 = '이차_수행_구취측정',
  일차_계획_TBI교육 = '일차_계획_TBI 교육',
  일차_수행_TBI교육 = '일차_수행_TBI 교육',
  이차_계획_TBI교육 = '이차_계획_TBI 교육',
  이차_수행_TBI교육 = '이차_수행_TBI 교육',
  이차_계획_치면열구전색 = '이차_계획_치면열구전색',
  이차_수행_치면열구전색 = '이차_수행_치면열구전색',
  이차_계획_와타나베칫솔질 = '이차_계획_와타나베 칫솔질',
  이차_수행_와타나베칫솔질 = '이차_수행_와타나베 칫솔질',
  이차_계획_치면연마 = '이차_계획_치면연마',
  이차_수행_치면연마 = '이차_수행_치면연마',
  일차_계획_기타 = '일차_계획_기타',
  일차_수행_기타 = '일차_수행_기타',
  이차_계획_기타 = '이차_계획_기타',
  이차_수행_기타 = '이차_수행_기타',
}

export const Treatment1PlanLabel = {
  [TreatmentType.일차_계획_불소도포]: '불소도포',
  [TreatmentType.일차_계획_구취측정]: '구취측정',
  [TreatmentType.일차_계획_TBI교육]: 'TBI 교육',
  [TreatmentType.일차_계획_기타]: '기타',
};

export const Treatment1ActionLabel = {
  [TreatmentType.일차_수행_불소도포]: '불소도포',
  [TreatmentType.일차_수행_구취측정]: '구취측정',
  [TreatmentType.일차_수행_TBI교육]: 'TBI 교육',
  [TreatmentType.일차_수행_기타]: '기타',
};

export const Treatment2PlanLabel = {
  [TreatmentType.이차_계획_치면열구전색]: '치면열구전색',
  [TreatmentType.이차_계획_와타나베칫솔질]: '와타나베 칫솔질',
  [TreatmentType.이차_계획_치면연마]: '치면연마',
  [TreatmentType.이차_계획_구취측정]: '구취측정',
  [TreatmentType.이차_계획_불소도포]: '불소도포',
  [TreatmentType.이차_계획_TBI교육]: 'TBI 교육',
  [TreatmentType.이차_계획_기타]: '기타',
};

export const Treatment2ActionLabel = {
  [TreatmentType.이차_수행_치면열구전색]: '치면열구전색',
  [TreatmentType.이차_수행_와타나베칫솔질]: '와타나베 칫솔질',
  [TreatmentType.이차_수행_치면연마]: '치면연마',
  [TreatmentType.이차_수행_구취측정]: '구취측정',
  [TreatmentType.이차_수행_불소도포]: '불소도포',
  [TreatmentType.이차_수행_TBI교육]: 'TBI 교육',
  [TreatmentType.이차_수행_기타]: '기타',
};

export const PreventiveDentalTreatmentChartFormDefaultValues = {
  [PreventiveDentalTreatmentChartFields.Treatment1Plan]: [],
  [PreventiveDentalTreatmentChartFields.Treatment1PlanDetail]: '',
  [PreventiveDentalTreatmentChartFields.Treatment1Action]: [],
  [PreventiveDentalTreatmentChartFields.Treatment1ActionDetail]: '',
  [PreventiveDentalTreatmentChartFields.Treatment2Plan]: [],
  [PreventiveDentalTreatmentChartFields.Treatment2PlanDetail]: '',
  [PreventiveDentalTreatmentChartFields.Treatment2Action]: [],
  [PreventiveDentalTreatmentChartFields.Treatment2ActionDetail]: '',
};
